import(/* webpackMode: "eager" */ "/opt/render/project/src/frontend/src/app/math-olympiad-prep/papers/[paper]/SitPaper.tsx")